import { z } from 'zod';
import { CoreShortLinkDomainSchema } from '../inputTypeSchemas/CoreShortLinkDomainSchema'
import { CoreShortLinkTypeSchema } from '../inputTypeSchemas/CoreShortLinkTypeSchema'

/////////////////////////////////////////
// CORE SHORT LINK SCHEMA
/////////////////////////////////////////

export const CoreShortLinkSchema = z.object({
  domain: CoreShortLinkDomainSchema,
  knownLinkType: CoreShortLinkTypeSchema.nullable(),
  id: z.bigint(),
  cityId: z.number().int(),
  knownLinkId: z.bigint().nullable(),
  longURL: z.string().nullable(),
  longURLHash: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CoreShortLink = z.infer<typeof CoreShortLinkSchema>

export default CoreShortLinkSchema;
